module.exports = __webpack_public_path__ + "img/QR-code-campus.806c65a4.png";